import { useTranslation } from 'react-i18next';
import MiniLoader from '../MiniLoader/MiniLoader';
import TextArea from '../TextArea/TextArea';
import NpsIcon from '@/images/nps.svg?react';
import Button from '../Button';

interface Props {
  comment: string;
  isLoading: boolean;
  setComment: (v: string) => void;
  sendComment: () => void;
  onClickSkip: () => void;
}

export const NPSCommentBlock = ({
  comment,
  isLoading,
  setComment,
  sendComment,
  onClickSkip,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className='px-6 pb-6'>
      <div>
        <div className='flex justify-center'>
          <NpsIcon />
        </div>
        <h2 className='mx-auto mb-6 max-w-[420px] text-center text-h4 font-extrabold leading-6'>
          {t(
            'Could you please elaborate on why you are unhappy with our service?'
          )}
        </h2>
      </div>
      <div className='grow'>
        <TextArea
          className='!pb-0'
          placeholder={'Your feedback'}
          value={comment}
          onChange={(e) => {
            setComment((e.target as HTMLTextAreaElement).value);
          }}
          name='feedback-textarea'
        />
        <Button
          disabled={isLoading}
          className='mt-4 flex !w-full items-center justify-center'
          onClick={sendComment}
          data-testid='send-feedback-btn'
        >
          {isLoading && <MiniLoader className='mr-2' color='gray' />}
          <span>{t('Send')}</span>
        </Button>
        <div className='mt-4 flex justify-center'>
          <Button
            className='!font-semibold'
            styling='naked-blue'
            onClick={onClickSkip}
          >
            {t('Skip')}
          </Button>
        </div>
      </div>
    </div>
  );
};
